import gql from 'graphql-tag'

export const productPriceSubscribeMutation = gql`
mutation productPriceSubscribe($id: ID!) {
    productPriceSubscribe(product_id: $id)
}
`
